var map = {
	"./karbur/img/1.png": 830,
	"./karbur/img/2.png": 3253,
	"./karbur/img/3.png": 5740,
	"./karbur/img/4.png": 9347,
	"./karbur/img/5.png": 8586,
	"./karbur/img/6.png": 7569,
	"./karbur/img/7.png": 4856,
	"./quicktalk/img/1.png": 1556,
	"./quicktalk/img/2.png": 463,
	"./quicktalk/img/3.png": 1446,
	"./quicktalk/img/4.png": 4521,
	"./quicktalk/img/old/1.png": 4278,
	"./quicktalk/img/old/2.png": 4957,
	"./quicktalk/img/old/3.png": 2452,
	"./quicktalk/img/old/4.png": 2395,
	"./src/mobile-mask.png": 8091,
	"./trainwatch/img/1.png": 2936,
	"./trainwatch/img/2.png": 7427,
	"./trainwatch/img/3.png": 8570,
	"./trainwatch/img/4.png": 3237,
	"./trainwatch/img/5.png": 3820,
	"./trainwatch/img/6.png": 4455,
	"./trainwatch/vid/1.mov": 2456,
	"./trainwatch/vid/2.mov": 5163,
	"./viruscamp/img/1.png": 9503,
	"./viruscamp/img/2.png": 4852,
	"./viruscamp/img/3.png": 4797,
	"./viruscamp/img/4.png": 2290,
	"./viruscamp/img/5.png": 6507,
	"./viruscamp/img/6.png": 8176,
	"./viruscamp/img/7.png": 3001,
	"./warehousemanager/img/1.png": 4625,
	"./warehousemanager/img/2.png": 6314,
	"./warehousemanager/img/3.png": 7891,
	"./warehousemanager/img/4.png": 7724,
	"./warehousemanager/img/5.png": 4261,
	"./warehousemanager/img/6.png": 8510,
	"./warehousemanager/img/7.png": 6199,
	"./warehousemanager/img/8.png": 2576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;